<div class="container-fluid main-content-area">
  <div class="row">
    <div class="col-lg-12">
      <p class="paragraph intro-text">
        Welcome to <strong>Lil Champ's Happy Bot</strong> - where cleanliness meets care! We're
        dedicated to creating a safe, fun, and hygienic environment for your little ones.
        From essential hygiene education to expert tips and services tailored for kids, our
        hub is your trusted partner in nurturing healthy habits from the very start. Because
        every champ deserves a fresh and happy start to their day!
      </p>
    </div>
  </div>

  <div class="row">
    <div class="col-xl-4 col-md-6 lil-champ-card-wrapper" *ngFor="let item of data">
      <div class="lil-champ-card" appScrollAnimate="animate__fadeIn">
        <ng-container *ngIf="item.type === 'game'; else otherCard">
          <a style="text-decoration: none" class="m-0 p-0" [href]="item.externalLink" >
            <img [src]="item.caDp" [alt]="item.caTitle" />
            <div class="card-title-overlay">
              <h5 class="card-title-text">{{ item.caTitle }}</h5>
            </div>
          </a>
        </ng-container>

        <ng-template #otherCard>
          <img (click)="cardRoute(item)" [src]="item.caDp" [alt]="item.caTitle" />
          <div *ngIf="item.caTitle === 'Comic Books'" class="card-title-overlay">
            <h5 class="card-title-text">{{ item.caTitle }}</h5>
          </div>
        </ng-template>
      </div>

      <ng-container *ngIf="item.type === 'game'; else routeButton">
        <a style="text-decoration: none" class="m-0 p-0" [href]="item.externalLink" target="_blank">
          <button class="btn lil-champ-btn">PLAY</button>
        </a>
      </ng-container>

      <ng-template #routeButton>
        <button (click)="cardRoute(item)" class="btn lil-champ-btn">
          {{ item.type === 'book' ? 'READ' : 'PLAY' }}
        </button>
      </ng-template>
    </div>
  </div>

</div>